 // @flow
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withTheme } from 'styled-components';
import { ComposedChart, Area, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Legend, Line, Tooltip } from 'recharts';
import { convertComparedMetricByTimeToGraphData, addIntersects, addAreaRanges } from '../../../domain/AudienceComparisonGraphData';
import { type MetricType, type Period } from '../../../domain/DashboardData';
import AudienceComparisonGraphTooltip from './AudienceComparisonGraphTooltip';

interface Props {
  comparedDataByTimeInterval: Object;
  period: Period;
  metricType: MetricType;
  t: any;
  theme: any;
}

class AudienceComparisonGraph extends Component<Props> {
  convertForChart(data: Object) {
    let convertedData = convertComparedMetricByTimeToGraphData(data);
    convertedData = addIntersects(convertedData);
    convertedData = addAreaRanges(convertedData);
    return convertedData;
  }

  formatXAxisTick(tick: number) {
    const hour = tick.toString().padStart(2, '0').concat('h');
    return hour;
  }

  formatYAxisTick(tick: number) {
    const thousand = (tick / 1000).toString().concat('K');
    return thousand;
  }

  getTicks(nbOfTicks: number): Array<number> {
    return Array.from(Array(nbOfTicks).keys());
  }

  render() {
    const { comparedDataByTimeInterval, period, metricType, t, theme } = this.props;
    const data = this.convertForChart(comparedDataByTimeInterval);
    const ticks = this.getTicks(24);
    const nbOfDays = period === 'weekly' ? 7 : 28;
    const linesColor = theme.V3.colors[metricType];

    return (
      <ResponsiveContainer width={'100%'} height={300} >
        <ComposedChart data={data} >
          <XAxis
            dataKey={'x'}
            interval={'preserveStart'}
            scale={'linear'}
            tickFormatter={this.formatXAxisTick}
            tickLine={false}
            tickSize={12}
            ticks={ticks}
          />
          <YAxis
            axisLine={false}
            tickFormatter={this.formatYAxisTick}
            tickLine={false}
            tickSize={6}
            width={48}
          />
          <Tooltip
            content={
              <AudienceComparisonGraphTooltip
                labelFormatter={this.formatXAxisTick}
                metricLabel={t(metricType)}
              />
            }
          />
          <Legend
            align={'left'}
            verticalAlign={'bottom'}
            iconSize={24}
            payload={[{ value: `${nbOfDays} ${t('lastDays')}`, type: 'plainline', color: linesColor, payload: {} },
                      { value: `${nbOfDays} ${t('previousDays')}`, type: 'plainline', color: linesColor, payload: { strokeDasharray: '4 4' } },
                      { value: t('increase'), type: 'circle', color: theme.V3.colors.gain.mediumLight },
                      { value: t('decrease'), type: 'circle', color: theme.V3.colors.loss.mediumLight }]}
            wrapperStyle={{
              paddingTop: '16px',
            }}
          />
          <CartesianGrid vertical={false} />
          <Area type={'linear'} dataKey={'currentRange'} stroke={'none'} fill={theme.V3.colors.gain.light} />
          <Area type={'linear'} dataKey={'comparedRange'} stroke={'none'} fill={theme.V3.colors.loss.light} />
          <Line type={'linear'} dataKey={'current'} stroke={linesColor} dot={false} />
          <Line type={'linear'} dataKey={'compared'} stroke={linesColor} dot={false} strokeDasharray={'2 2'} />
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}

export default translate('dashboard')(withTheme(AudienceComparisonGraph));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/AudienceComparisonGraph.js